/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.giftCards.internal

import features.giftCards.models.GiftCardsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class GiftCardsRequest : NetworkRequest() {

    suspend fun getGiftCards(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<GiftCardsModel> {
        return safeNetworkCall {
            get(
                endpoint = GiftCardsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
